import React, { useEffect, useState } from "react"
import { useSelector } from "react-redux"

import { IDLE, PENDING } from "const"
import { RrsTemplateLevel } from "server/models"
import { StateType } from "client/utils"
import {
    StoreType,
    LoadRrsTemplateLevelById,
    initRrsTemplateLevel,
} from "client/store"
import {
    Container,
    PageHeader,
    PageTitle,
    PageContent,
    Loader,
} from "client/components"

import NotFound from "client/parts/notFound"
import Form from "./form"

interface TemplateLevelEditProps {
    levelId: number
    labelId?: number
    categoryId?: number
}
const TemplateLevelEdit = ({
    levelId = null,
    labelId = null,
    categoryId = null,
}: TemplateLevelEditProps) => {
    const lang = useSelector((state: StoreType) => state.system.lang)

    const [level, setLevel] = useState<RrsTemplateLevel>(initRrsTemplateLevel)
    const [loadState, setLoadState] = useState<StateType>(IDLE)
    const [reloadEdit, setReloadEdit] = useState(true)

    const reload = () => {
        setReloadEdit(false)
        setTimeout(() => {
            setReloadEdit(true)
        }, 0)
    }

    useEffect(() => {
        if (levelId === 0) {
            setLevel({
                ...initRrsTemplateLevel,
                labelId,
                categoryId: categoryId || null,
            })
            reload()
        } else {
            setLoadState(PENDING)
            LoadRrsTemplateLevelById(levelId).then((res) => {
                setLoadState(IDLE)
                setLevel(res)
                reload()
            })
        }
    }, [])

    if (!level) return <NotFound />
    return (
        <Container>
            <PageHeader>
                <PageTitle>{level.id ? `${lang.editLevel} # ${level.id}` : lang.addLevel}</PageTitle>
            </PageHeader>
            <PageContent>
                {loadState === PENDING && <Loader />}
                {
                    !reloadEdit
                    && <Form level={level} />
                }
                {
                    reloadEdit
                    && <Form level={level} />
                }
            </PageContent>
        </Container>
    )
}
export default TemplateLevelEdit
